module.exports = __webpack_public_path__ + "static/media/favorite-books.6039457c.jpg";